import { render, staticRenderFns } from "./todo-list.vue?vue&type=template&id=305a8146&"
import script from "./todo-list.vue?vue&type=script&lang=ts&"
export * from "./todo-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports